
import React from 'react';
import {  fuel, maxspeed, milage, minspeed, speed, trips,avgspeed } from '../../common/svg';
import SecureImage from "../../components/BucketImage/Image";
// Define types for our stats
interface VehicleStats {
  startingOdo: number;
  finalOdo: number;
  avgMileage: number;
  fuelConsumption: number;
  totalDistance: number;
  currentFuelLevel: number;
  minSpeed: number;
  maxSpeed: number;
  avgSpeed: number;
  days: number;
  hours: number;
  minutes: number;
}

const VehicleDashboard: React.FC = () => {
  // Sample data
  const stats: VehicleStats = {
    startingOdo: 6473882,
    finalOdo: 6473882,
    avgMileage: 11,
    fuelConsumption: 45,
    totalDistance: 1464,
    currentFuelLevel: 450,
    minSpeed: 40,
    maxSpeed: 95,
    avgSpeed: 63,
    days: 3,
    hours: 11,
    minutes: 50
  };
  return (
    <div className="p-4  gap-20 mr-10 ">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-5 ">
        {/* Starting ODO */}
        <div className="bg-[#FFF5EC] w-[160px] h-[70px] rounded-[20px] border border-[#FFB470] mr-[100px] ">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-4 ml-4">Starting ODO</span>
          <div className="flex items-center">
            <div className="mr-2">
            <SecureImage
              
              fileKey={speed}
              alt="Over Speed"
              width="27px"
              className="w-[27px] h-[27px] ml-3" 
            />
            </div>
            <span className="text-[16px] text-[#282828] font-[600] font-poppins">{stats.startingOdo.toLocaleString()} Km</span>
          </div>
        </div>

        {/* Final ODO */}
        <div className="bg-blue-50 w-[160px] h-[70px]  rounded-[20px] mr-20  border border-[#497AFF] flex flex-col">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1 ml-4">Final ODO</span>
          <div className="flex items-center">
            <div className="mr-2">
            <SecureImage
              
              fileKey={speed}
              alt="Over Speed"
              width="27px"
              className="w-[27px] h-[27px] ml-3"
            />
            </div>
            <span className="text-[16px] text-[#282828] font-[600] font-poppins">{stats.finalOdo.toLocaleString()} Km</span>
          </div>
        </div>

        {/* Avg Mileage */}
        <div className="bg-[#FFECE9] w-[160px] h-[70px]  rounded-[20px] border border-[#FF9788] flex flex-col">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1 ml-4">Avg Mileage</span>
          <div className="flex items-center">
            <div className="mr-2">
            <SecureImage
              
              fileKey={milage}
              alt="Over Speed"
              width="27px"
              className="w-[27px] h-[27px] ml-3" 
            />
            </div>
            <span className="text-[18px] text-[#282828] font-[600] font-poppins ml-8">{stats.avgMileage} Km/L</span>
          </div>
        </div>

        {/* Fuel Consumption */}
        <div className="bg-[#FFF1E4] w-[160px] h-[70px]  rounded-[20px] border border-[#FFC692] flex flex-col">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1 ml-4">Fuel Consumption</span>
          <div className="flex items-center">
            <div className="mr-2"> 
            <SecureImage
              
              fileKey={fuel}
              alt="Over Speed"
              width="27px"
              className="w-[27px] h-[27px] ml-3" 
            />
            </div>
            <span className="text-[18px] text-[#282828] font-[600] font-poppins ml-10">{stats.fuelConsumption} L</span>
          </div>
        </div>

        {/* Total Distance */}
        <div className="bg-[#ECFFEB] w-[210px] h-[130px] mt-5 mr-2 rounded-[20px] border border-[#05D901] flex flex-col row-span-2">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1 mt-2 ml-4">Total Distance</span>
          <div className="flex items-center mb-4">
            <div className="mr-2">
            <SecureImage
              
              fileKey={trips}
              alt="Over Speed"
              width="34px"
              className="w-[34px] h-[34px] ml-3 mt-3 "
            />
            </div>
            <span className="text-[18px] text-[#282828] font-[600] font-poppins ml-10 mt-3">{stats.totalDistance} Kms</span>
          </div>
          <div className="text-center mt-2">
            <span className="text-[16px] text-[#282828] font-[400] font-poppins ">{stats.days} Days, {stats.hours} Hrs {stats.minutes} Mins</span>
          </div>
        </div>

        {/* Current Fuel Level */}
        <div className="bg-white w-[160px] h-[70px]  rounded-[20px] border border-[#EAEAEA] ">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1  ml-4">Current Fuel Level</span>
          <div className="flex items-center">
            <div className="mr-2">
            <SecureImage
              
              fileKey={fuel}
              alt="Over Speed"
              width="27px"
              className="w-[27px] h-[27px] ml-3" 
            />
            </div>
            <span className="text-[18px] text-[#282828] font-[600] font-poppins ml-10">{stats.currentFuelLevel} L</span>
          </div>
        </div>

        {/* Min Speed */}
        <div className="bg-white w-[160px] h-[70px]  rounded-[20px] border border-[#EAEAEA]flex flex-col">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1 ml-4">Min Speed</span>
            <div className="flex items-center">
            <div className="mr-2">
            <SecureImage
              
              fileKey={minspeed}
              alt="Over Speed"
              width="27px"
              className="w-[27px] h-[27px] ml-3" 
            />
            </div>
            <span className="text-[18px] text-[#282828] font-[600] font-poppins">{stats.minSpeed} Kmph</span>
          </div>
        </div>

        {/* Max Speed */}
        <div className="bg-white w-[160px] h-[70px]  rounded-[20px] border border-[#EAEAEA] flex flex-col">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1 ml-4">Max Speed</span>
          <div className="flex items-center">
            <div className="mr-2">
            <SecureImage
              
              fileKey={maxspeed}
              alt="Over Speed"
              width="27px"
              className="w-[27px] h-[27px] ml-3" 
            />
            </div> 
            <span className="text-[18px] text-[#282828] font-[600] font-poppins">{stats.maxSpeed} Kmph</span>
          </div>
        </div>

        {/* Avg Speed */}
        <div className="bg-white w-[160px] h-[70px]  rounded-[20px] border border-[#EAEAEA] flex flex-col">
          <span className="text-[14px] text-[#282828] font-[400] font-poppins mb-1 ml-4">Avg Speed</span>
          <div className="flex items-center">
            <div className="mr-2">
            <SecureImage
              
              fileKey={avgspeed}
              alt="Over Speed"
              width="27px"
              className="w-[27px] h-[27px] ml-3" 
            />
            </div>
            <span className="text-[18px] text-[#282828] font-[600] font-poppins">{stats.avgSpeed} Kmph</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleDashboard;
